
// Provide a global object polyfill for browser environments
if (typeof window !== 'undefined') {
  window.global = window;
}

export default window.global;
